import { getScriptarioLocalizedPath, normalizeScriptarioLocale } from "@/config/locales";

export type SiteMarket = "transcripta" | "scriptario";
export type SiteLocale = "ru" | "en" | "es" | "pt-br" | "it" | "de";

export interface SiteTheme {
  primary: string;
  primaryHover: string;
  primaryLight: string;
  primaryLighter: string;
  primaryTint: string;
  primarySoft: string;
  segmentBg: string;
  logo: {
    shortBar: string;
    mediumBar: string;
    tallBar: string;
    baseBar: string;
    sparkle: string;
  };
}

export interface SiteConfig {
  siteId: SiteMarket;
  market: SiteMarket;
  locale: SiteLocale;
  brandName: string;
  domain: string;
  supportEmail: string;
  supportUrl: string;
  contactsEnabled: boolean;
  blogEnabled: boolean;
  seoPagesEnabled: boolean;
  analyticsEnabled: boolean;
  ctaMode: "app" | "coming-soon";
  theme: SiteTheme;
  legal: {
    privacyPath: string;
    termsPath?: string;
    cookiePath?: string;
    ofertaPath?: string;
    dataProcessingPath?: string;
  };
}

const locale = normalizeScriptarioLocale(process.env.NEXT_PUBLIC_LOCALE);

const blueTheme: SiteTheme = {
  primary: "#256CFF",
  primaryHover: "#1A4FB8",
  primaryLight: "#3375FF",
  primaryLighter: "#B8D6FF",
  primaryTint: "#E8F0FF",
  primarySoft: "#D9ECFF",
  segmentBg: "#D9ECFF",
  logo: {
    shortBar: "#4D87FF",
    mediumBar: "#407EFF",
    tallBar: "#3375FF",
    baseBar: "#256CFF",
    sparkle: "#256CFF",
  },
};

export const siteConfig: SiteConfig = {
  siteId: "scriptario",
  market: "scriptario",
  locale,
  brandName: "Scriptario",
  domain: "https://scriptario.com",
  supportEmail: "hello@scriptario.com",
  supportUrl: "https://wa.me/447732727913",
  contactsEnabled: true,
  blogEnabled: false,
  seoPagesEnabled: true,
  analyticsEnabled: true,
  ctaMode: "app",
  theme: blueTheme,
  legal: {
    privacyPath: getScriptarioLocalizedPath("/privacy-policy", locale),
    termsPath: getScriptarioLocalizedPath("/terms", locale),
    cookiePath: getScriptarioLocalizedPath("/cookie-policy", locale),
  },
};

export const isScriptarioMarket = true;
